import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { ReportEventEnum, TableComponentCodes } from "../../../config/app-globals.enum";
import {
  getPraisoTableData,
  getPraisoTableSettings,
} from "../../../services/PraisoTableService";
import ContentEngagementTab from "../../ContentEngagementTab/ContentEngagementTab";
import ErrorAlert from "../../ErrorAlert/ErrorAlert";
import ReportedEventsAccordion from "../../ReportedEventsAccordion/ReportedEventsAccordion";
import CustomLoader from "../CustomLoader/CustomLoader";
import { getExpander, getTableColumns } from "./Columns";
import { PraisoTable } from "./PraisoTable";
import { getMileageClaimDateRange, meterToMiles } from "../../../assets/helperFunctions";

const PraisoTableWrapper = React.forwardRef((props: any, ref: any) => {
  const params = useParams();
  // const { preFetchedTableData } = props;
  const hideGlobalFilter = props.hideGlobalFilter;
  const hidePagination = props.hidePagination;
  const isRowExpanded = props.isRowExpanded;
  const isHideTableSelector = props.isHideTableSelector;
  const { t } = useTranslation();
  const changeTableSettingsApiStatusCodeFunc = (status) => {
    if (status.code && status.code !== 0 && status.code !== 200) {
      setTableSettingsStatusValue(status.code);
      setTableSettingsAlertMessage(
        status.message
          ? status.message
          : "Something went wrong, kindly retry after sometime."
      );
      setTableSettingsIsAlertOpen(true);
    }
  };
  const [tableSettings, setTableSettings] = React.useState(null);
  // const [preFetchedDataState, setPreFetchedDataState,] = useState(null);
  const [tableSettingsStatusValue, setTableSettingsStatusValue] =
    React.useState(null);
  const [tableSettingsApi, setTableSettingsApi] = React.useState(false);
  const [tableSettingsApiFailed, setTableSettingsApiFailed] = React.useState(false);
  const [tableSettingsAlertMessage, setTableSettingsAlertMessage] =
    React.useState("");
  const [tableSettingsIsAlertOpen, setTableSettingsIsAlertOpen] =
    React.useState(false);
  async function getTableSettings() {
    setTableSettingsApi(true);
    setTableSettingsStatusValue(null);
    setTableSettingsAlertMessage("");
    setTableSettingsIsAlertOpen(false);
    const data = await getPraisoTableSettings(
      props.getTableSettingAPI,
      props.tableSettingView, t, params
    );
    if (
      data &&
      (data.status.code === 0 ||
        data.status.code === 200 ||
        data.status.code === 201) &&
      data.content
    ) {
      if (data.content.length > 0) {
        setTableSettings(data.content);
      }
    } else {
      setTableSettingsApiFailed(true);
      changeTableSettingsApiStatusCodeFunc(data.status);
    }
    setTableSettingsApi(false);
  }
  React.useEffect(() => {
    getTableSettings();
  }, [props.getTableSettingAPI]);


  const changeTableDataApiStatusCodeFunc = (status) => {
    if (status.code && status.code !== 0 && status.code !== 200) {
      setTableDataStatusValue(status.code);
      setTableDataAlertMessage(
        status.message
          ? status.message
          : "Something went wrong, kindly retry after sometime."
      );
      setTableDataIsAlertOpen(true);
    }
  };
  const [tableData, setTableData] = useState([]);
  const [tableDataStatusValue, setTableDataStatusValue] = React.useState(null);
  const [tableDataApi, setTableDataApi] = React.useState(false);
  // const [tableDataApiFailed, setTableDataApiFailed] = React.useState(false);
  const [tableDataAlertMessage, setTableDataAlertMessage] = React.useState("");
  const [tableDataIsAlertOpen, setTableDataIsAlertOpen] = React.useState(false);

  const [selectedTableSettings, setSelectedTableSettings] = useState(null);
  const [tableColumns, setTableColumns] = useState([]);
  const [selectedTableSorting, setSelectedTableSorting] = useState([]);
  const [selectedTableGrouping, setSelectedTableGrouping] = useState([]);
  const [selectedTableHiddenCell, setSelectedTableHiddenCell] = useState([]);
  // const [selectedTableRequiredCell, setSelectedTableRequiredCell] = useState([]);
  const [selectedTableFilter, setSelectedTableFilter] = useState([]);
  const [tableViewList, setTableViewList] = useState([]);
  // const [eventCategory, setEventCategory] = useState(props.eventCategory);

  async function getTableData(forceRefresh: boolean = false) {
    if (!props.getTableDataAPI) {
      return;
    }
    setTableDataApi(true);
    setTableDataStatusValue(null);
    setTableDataAlertMessage("");
    setTableDataIsAlertOpen(false);
    const data = await getPraisoTableData({ apiUrl: props.getTableDataAPI, apiParam: props.getTableDataApiParam, }, params, props.tableSettingView, forceRefresh);
    if (data && (data.status.code === 0 || data.status.code === 200 || data.status.code === 201) && data.content) {
      if (props.tableDataApiResponseProperty && props.tableDataApiResponseProperty.length) {
        if (data.content[props.tableDataApiResponseProperty] && data.content[props.tableDataApiResponseProperty].length) {
          setTableData(data.content[props.tableDataApiResponseProperty]);
        } else if (props.tableDataApiResponseProperty === "distractionEventDetails") {
          if (data?.content?.length > 0) {
            let dataArray = [];
            data.content.map((item) => {
              let startAddress = item.startAddress ? `${item?.startAddress?.featureName} ${item?.startAddress?.subAdminArea},${item?.startAddress?.postalCode} ${item?.startAddress?.adminArea}, ${item?.startAddress?.countryName}` : '';
              let endAddress = item.endAddress ? `${item?.endAddress?.featureName} ${item?.endAddress?.subAdminArea},${item?.endAddress?.postalCode} ${item?.endAddress?.adminArea}, ${item?.endAddress?.countryName}` : '';

              let concatAddress = startAddress.length > 0 && endAddress.length > 0 ? `${startAddress} ${endAddress}` : '-';
              let duration = secondsToHms(item?.duration)
              let obj = {
                ...item,
                address: concatAddress,
                duration: duration
              }
              dataArray.push(obj);
            })
            setTableData(dataArray);
          }
        } else if (props.tableDataApiResponseProperty === "mileageClaimList") {
          if (data?.content?.length > 0) {
            let dataList = [];
            data.content.map((item) => {
              let daterange = getMileageClaimDateRange(new Date(item.claimFrom), new Date(item.claimTo));
              let distanceInMiles = meterToMiles(item.distanceInMeter, true);
              dataList.push({
                ...item,
                daterange,
                distanceInMiles,
              });
            });
            setTableData(dataList);
          } else {
            setTableData([]);
          }
        } else {
          setTableData([]);
        }
      } else {
        if (data.content.length) {
          setTableData(data.content);
        } else {
          setTableData([]);
        }
      }
    } else {
      // setTableDataApiFailed(true);
      changeTableDataApiStatusCodeFunc(data.status);
    }
    setTableDataApi(false);
  }

  function secondsToHms(d: any) {
    try {
      var h, m, s: any;
      let duration: any;
      if (d && d > 0 && Number((d / 3600).toFixed(2)) >= 1) {
        h = Math.floor(d / 3600);
        m = Math.floor(d % 3600 / 60);
        duration = `${h} Hrs : ${m} Mins`;
      } else if (d && d > 0 && Number((d / 60).toFixed(2)) > 1 && Number((d / 60).toFixed(2)) < 60) {
        m = Math.floor(d % 3600 / 60);
        s = Math.floor(d % 3600 % 60);
        duration = `${m} Mins : ${s} Secs`;
      } else if (d && d > 0) {
        s = Math.floor(d % 3600 % 60);
        duration = `${s} Secs`;
      } else {
        duration = "-"
      }
      return duration;
    } catch (error) {
      console.warn(error);
    }
  }

  async function getTableAPI() {
    if (props.getTableDataAPI && props.getTableDataApiParam && selectedTableSettings && !tableDataApi) {
      getTableData();
    } else if (props.preFetchedTableData) {
      if (props.tableSettingView === TableComponentCodes.MOBILE_DISTRACTION) {
        let dataArray = [];
        if (props?.preFetchedTableData?.length > 0) {
          props.preFetchedTableData.map((item: any) => {
            let startAddress = item.startAddress ? `${item?.startAddress?.featureName} ${item?.startAddress?.subAdminArea},${item?.startAddress?.postalCode} ${item?.startAddress?.adminArea}, ${item?.startAddress?.countryName}` : '';
            let endAddress = item.endAddress ? `${item?.endAddress?.featureName} ${item?.endAddress?.subAdminArea},${item?.endAddress?.postalCode} ${item?.endAddress?.adminArea}, ${item?.endAddress?.countryName}` : '';
            let duration = secondsToHms(item?.duration);
            let concatAddress = startAddress.length > 0 && endAddress.length > 0 ? `${startAddress} ${endAddress}` : '-';

            let obj = {
              ...item,
              address: concatAddress,
              duration: duration,
            }
            dataArray.push(obj);
          })
        }
        setTableData(dataArray);
      }
      else if (props.tableSettingView !== 'userSearchList' && props.tableSettingView !== TableComponentCodes.MOBILE_DISTRACTION) {
        setTableDataApi(false); // true
        setTableData(props.preFetchedTableData);
      }
      else {
        //For Admin Search Result
        setTableData(props.preFetchedTableData);
      }
    }
  }

  React.useEffect(() => {
    getTableAPI();
  }, [
    selectedTableSettings,
    props.getTableDataAPI,
    props.getTableDataApiParam,
    props.preFetchedTableData,
  ]);

  React.useEffect(() => {
    getTableData(true);
  }, [props.trigger]);

  React.useEffect(() => {
    if (tableSettings && tableSettings.length) {
      const localViewId = window.localStorage.getItem("viewId");
      let selectedView = tableSettings.find((setting) => setting.isDefault);
      if (localViewId === null) {
        setSelectedTableSettings(selectedView);
      } else {
        selectedView = tableSettings.find((setting) => setting.id === localViewId);
        if (selectedView) {
          setSelectedTableSettings(selectedView);
        } else {
          selectedView = tableSettings.find((setting) => setting.isDefault);
          setSelectedTableSettings(selectedView);
        }
      }
      const _tableSettings = tableSettings.map((setting) => {
        return {
          id: setting.id,
          tableName: setting.tableName,
          isDefault: setting.isDefault,
          isSelected: setting.id === selectedView.id ? true : false,
          isSystemDefault: setting.isSystemDefault,
          selectColumn: setting.selectColumn
        };
      });
      setTableViewList([..._tableSettings]);
    }
  }, [tableSettings]);

  const handleCallBack = (eventStatus?) => {
    if (eventStatus === ReportEventEnum.REPORT_EVENT) {
      if (props.preFetchedTableData && props.preFetchedTableData.length > 0) {
        props.callBackFun();
      } else {
        setTableDataApi(true);
        getTableAPI();
        setTableDataApi(false);
      }
    } else {
      if (props?.callBackFun && props?.callBackFun !== undefined) {
        props.callBackFun(true);
      }
    }
  }

  React.useEffect(() => {
    if (
      selectedTableSettings &&
      selectedTableSettings.tableConfiguration &&
      selectedTableSettings.tableConfiguration.columns
    ) {
      const selectedTableColumnObj = getTableColumns(
        selectedTableSettings.tableConfiguration.columns,
        selectedTableSettings.tableConfiguration.isAccordionEnable,
        selectedTableSettings.tableConfiguration.isGroupByEnable,
        props.defaultFilterBy,
        props.tableSettingView,
        handleCallBack,
      );
      setSelectedTableSorting(selectedTableColumnObj.defaultSortedBy);
      setSelectedTableGrouping(selectedTableColumnObj.defaultGroupedBy);
      setSelectedTableHiddenCell(selectedTableColumnObj.defaultHiddenColumns);
      // setSelectedTableRequiredCell(selectedTableColumnObj.defaultRequiredColumns);
      setSelectedTableFilter(selectedTableColumnObj.defaultFilter)
      let rowExpander;
      if (
        props.tableAccordion &&
        selectedTableSettings.tableConfiguration.isAccordionEnable &&
        !selectedTableSettings.tableConfiguration.isGroupByEnable
      ) {
        rowExpander = getExpander(
          props.tableAccordion,
          selectedTableSettings.tableConfiguration.isAccordionEnable,
          selectedTableSettings.tableConfiguration.isGroupByEnable, props
        );
      }
      if (rowExpander) {
        setTableColumns([...selectedTableColumnObj.tableColumns, rowExpander]);
      } else {
        setTableColumns([...selectedTableColumnObj.tableColumns]);
      }
    }
  }, [selectedTableSettings, props.defaultFilterBy]);

  const DynamicComponents = {
    ReportedEventsAccordion: ReportedEventsAccordion,
    ContentEngagementTab: ContentEngagementTab,
  };
  const DynamicComponent = (props) => {
    const { Component, componentProps, data } = props;
    let _props = {};
    for (const [key, value] of Object.entries(componentProps)) {
      _props[key] = data && data[key] ? data[key] : value ? value : null;
    }
    return React.createElement(DynamicComponents[Component], { ..._props });
  };
  const renderRowSubComponent = React.useCallback(
    ({ row }, Component, componentProps) => (
      <>
        {row && Component && componentProps ? (
          <DynamicComponent
            Component={Component}
            componentProps={componentProps}
            data={row.original}
          />
        ) : null}
      </>
    ),
    []
  );

  const changeTableView = (viewId) => {
    window.localStorage.setItem("viewId", viewId);
    const _tableViewList = [...tableViewList];
    if (_tableViewList && _tableViewList.length) {
      const currentSelectedViewIndex = _tableViewList.findIndex(
        (view) => view.isSelected === true
      );
      if (currentSelectedViewIndex >= 0) {
        _tableViewList[currentSelectedViewIndex].isSelected = false;
      }
      const newSelectedViewIndex = _tableViewList.findIndex(
        (view) => view.id === viewId
      );
      if (newSelectedViewIndex >= 0) {
        _tableViewList[newSelectedViewIndex].isSelected = true;
      }
      setTableViewList([..._tableViewList]);
      setSelectedTableSettings(
        tableSettings.find((setting) => setting.id === viewId)
      );
      handleCallBack();
    }
  };

  const handleRefreshComponentFunc = () => {
    //Refresh component when copy and delete operation performed
    getTableSettings();
    props.callBackFun();
  }

  return (
    <>
      {tableSettingsApi && !tableSettingsApiFailed ? (
        <CustomLoader />
      ) : !tableSettingsApi &&
        !tableSettingsApiFailed &&
        tableSettings &&
        tableSettings.length &&
        tableColumns &&
        tableColumns.length ? (
        <PraisoTable
          ref={ref}
          tableColumns={tableColumns}
          tableData={tableData}
          tableName={selectedTableSettings.tableName}
          globalFilterEnabled={
            hideGlobalFilter ? false : selectedTableSettings.tableConfiguration.isGlobalFilterEnable
          }
          globalFilterPlaceholder={
            selectedTableSettings.tableConfiguration.globalFilterPlaceholder
          }
          groupByEnabled={
            selectedTableSettings.tableConfiguration.isGroupByEnable
          }
          pageLengthArray={
            selectedTableSettings.tableConfiguration.pageLengthArray
          }
          defaultPageSize={
            selectedTableSettings.tableConfiguration.defaultPageSize
          }
          showPagination={
            hidePagination ? false : selectedTableSettings.tableConfiguration.showPagination
          }
          isRowExpanded={
            isRowExpanded ? true : false
          }
          isHideTableSelector={isHideTableSelector ? true : false}
          selectedTableSorting={selectedTableSorting}
          selectedTableGrouping={selectedTableGrouping}
          selectedTableHiddenCell={selectedTableHiddenCell}
          selectedTableFilter={selectedTableFilter}
          loading={tableDataApi}
          isAccordionView={
            selectedTableSettings.tableConfiguration.isAccordionEnable
          }
          tableAccordionProps={props.tableAccordion}
          renderRowSubComponent={renderRowSubComponent}
          showMoreOrLessComp={props.showMoreOrLessComp}
          tableViewList={tableViewList}
          changeTableView={changeTableView}
          handleRefreshComponent={handleRefreshComponentFunc}
          isShowGlobalDropDown={props.isShowGlobalDropDown}
          // eventCategory={eventCategory}
          // setEventCategory={setEventCategory}
          {...props}
        />
      ) : null}
      <ErrorAlert
        code={tableSettingsStatusValue}
        message={tableSettingsAlertMessage}
        isOpen={tableSettingsIsAlertOpen}
      />
      <ErrorAlert
        code={tableDataStatusValue}
        message={tableDataAlertMessage}
        isOpen={tableDataIsAlertOpen}
      />
    </>
  );
});

export default PraisoTableWrapper;
